import { Core, Decorative } from "@faire/design-tokens";
import { ContactUsButton } from "@faire/help-center-self-serve/components/ContactUsButton";
import { SelfServeSource } from "@faire/help-center-self-serve/consts";
import { ChatBubble } from "@faire/web/slate/icons/foundation/ChatBubble";
import { Column, Row } from "@faire/web/slate/Layout";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var ContactUsSideBanner = function ContactUsSideBanner(_ref) {
  var isFooter = _ref.isFooter;
  var _useViewport = useViewport(),
    isMobile = _useViewport.isMobile;
  return /*#__PURE__*/React.createElement(Wrapper, {
    "$isFooter": isFooter
  }, isMobile ? ( /*#__PURE__*/React.createElement(ChatBubbleWrapper, null, /*#__PURE__*/React.createElement(ChatBubble, {
    fontSize: "22px"
  }))) : null, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Es/u1J",
    defaultMessage: "Need more help?"
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraphSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "nSILmm",
    defaultMessage: "Share more about your issue, and get in touch with our support team."
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(FullWidthContactUsButton, {
    source: isFooter ? SelfServeSource.CONTACT_US_FOOTER_BANNER : SelfServeSource.CONTACT_US_SIDE_BANNER,
    variant: !isMobile && !isFooter ? "secondary" : "primary"
  }));
};
var Wrapper = styled(Column).attrs({
  align: "flex-start"
}).withConfig({
  displayName: "ContactUsSideBanner__Wrapper"
})(["", " padding:", ";background-color:", ";", "{background-color:", ";}"], function (_ref2) {
  var $isFooter = _ref2.$isFooter;
  return !$isFooter && "border: 1px solid ".concat(Core.border.muted, ";");
}, getSpacing("4x", "3x"), Core.surface.inverse, responsiveMediaQueries.mobile, Decorative.tint.orange);
var FullWidthContactUsButton = styled(ContactUsButton).withConfig({
  displayName: "ContactUsSideBanner__FullWidthContactUsButton"
})(["width:100%;"]);
var ChatBubbleWrapper = styled(Row).withConfig({
  displayName: "ContactUsSideBanner__ChatBubbleWrapper"
})(["padding:", ";border-radius:50%;border:1px solid ", ";background-color:", ";margin-bottom:", ";"], getSpacing("3x"), Core.surface.inverse, Core.surface.inverse, getSpacing("1x"));